import React, { useEffect, useState } from 'react'
import './OurActivities.scss'

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'

import { Pagination } from 'swiper/modules'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function OurActivities() {
  const [swiper, setSwiper] = useState(null)

  const handleOnSetSwiperOne = () => {
    swiper.slideTo(0)
  }

  // const handleOnSetSwiperTwo = () => {
  //   swiper.slideTo(1)
  // }

  const handleOnSetSwiperThree = () => {
    swiper.slideTo(1)
  }

  const handleOnSetSwiperFour = () => {
    swiper.slideTo(2)
  }

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='mainActivity' data-aos= 'fade-left'>
      <div className='slider'>
        <Swiper pagination={true} modules={[Pagination]} className='mySwiper' onSwiper={setSwiper}>
          <SwiperSlide>
            <div className="mainActivity_sliderOne">
              <h2 className="mainActivity_content">
                ÇELİK SANAYİ<br />
                ÜRÜNLER
              </h2>
            </div>
          </SwiperSlide>
          {/* <SwiperSlide>
            <div className="mainActivity_sliderTwo">
              <h2 className="mainActivity_content">
                MSW TESİSİ,GERİ <br />
                DÖNÜŞÜM VE GÜÇ İÇİN <br />
                ATIK TESİS PROJESİ
              </h2>
              
            </div>
          </SwiperSlide> */}
          <SwiperSlide>
            <div className="mainActivity_sliderThree">
              <h2 className="mainActivity_content">
                BİNA VE<br />
                YAPI
              </h2>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="mainActivity_sliderFour">
              <h2 className="mainActivity_content">
                GENEL<br />
                TİCARET
              </h2>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className='container'>
        <div className='row'>
          <div className='content'>
            <h2 className='title'>
              ANA FAALİYETLERİMİZ 
            </h2>
            <h3 className='subtitle'>
              Global Enerji Yatırım ve ortağının lider şirketleri, Çelik Sanayi, İnşaat. 
            </h3>
            <div className='buttonsTr'>
              <div className='row_buttons'>
                <div className='button' onMouseEnter={handleOnSetSwiperOne}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      Çelik Sanayi Ürünleri
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      Filmaşin, Çelik İnşaat Demiri, Çelik Külçe <br />
                      (kütük), Galvanizli tel
                    </div>
                  </div>
                </div>

                <div className='button3' onMouseEnter={handleOnSetSwiperThree}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      Bina inşaatı
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      İnşaat projelerine katılım ve yatırım
                    </div>
                  </div>
                </div>

                {/* <div className='button2' onMouseEnter={handleOnSetSwiperTwo}>
                  <div className='img'>
                    
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      MSW tesisi, geri dönüşüm ve atıklardan enerji santraline proje 
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      Atıktan Türetilmiş Yakıt (RDF), Geri  ...
                    </div>
                  </div>
                </div> */}
              </div>

              <div className='row_buttons'>
                <div className='button4' onMouseEnter={handleOnSetSwiperFour}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      Genel Ticaret
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      Çelik ürünler , İnşaat, endüstriyel ve mineral malzemeler ...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
